import { InspectionTemplateItemModel } from 'components/dataProviders/withRequiredInspectionTemplate/types';

export function findLastClickedItem(
  lastClickedItemId: string | null,
  list: InspectionTemplateItemModel[]
): InspectionTemplateItemModel | undefined {
  return list.find((item) => item._id === lastClickedItemId);
}

function calculateCenteredScrollPosition(
  elementRect: DOMRect,
  containerRect: DOMRect,
  currentScrollTop: number
): number {
  const elementTopRelativeToContainer = 
    elementRect.top - containerRect.top + currentScrollTop;
  
  const containerCenter = containerRect.height / 2;
  const elementCenter = elementRect.height / 2;
  
  return elementTopRelativeToContainer - containerCenter + elementCenter;
}

function scrollWithinContainer(
  element: Element,
  container: Element
): void {
  const containerRect = container.getBoundingClientRect();
  const elementRect = element.getBoundingClientRect();
  
  const targetScrollTop = calculateCenteredScrollPosition(
    elementRect,
    containerRect,
    container.scrollTop
  );
  
  container.scrollTo({
    top: targetScrollTop,
    behavior: 'smooth',
  });
}

function scrollInDocument(element: Element): void {
  element.scrollIntoView({ 
    behavior: 'smooth', 
    block: 'center' 
  });
}

function scrollToElement(
  element: Element | null, 
  container: Element | null
): void {
  if (!element) return;
  
  container 
    ? scrollWithinContainer(element, container)
    : scrollInDocument(element);
}
export function scrollToActiveCard(
  cardElement: HTMLElement | undefined,
  container: HTMLElement | undefined
): void {
  scrollToElement(cardElement ?? null, container ?? null);
}
